import React, { useState } from "react";
import MyStudentLayout from "./../../../layouts/Student/MyStudentLayout";
import "../../../assets/css/student/Dashboard.css";

/* ── Icons ── */
const CheckIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const BookIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
  </svg>
);
const ClockIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
);
const ChevronL = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronR = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const StarIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);
const ShieldIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);
const UsersIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

/* ── Calendar helpers ── */
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const DAYS = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];

function getDaysInMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}
function getFirstDay(y, m) {
  const d = new Date(y, m, 1).getDay();
  return d === 0 ? 6 : d - 1;
}

/* ── Chart data ── */
const WEEK_DATA = [
  { day: "Mo", hours: 5.1 },
  { day: "Tu", hours: 6.3 },
  { day: "We", hours: 4.2 },
  { day: "Th", hours: 7.5 },
  { day: "Fr", hours: 6.8 },
  { day: "Sa", hours: 2.4 },
  { day: "Su", hours: 5.6 },
];
const MAX_H = 8;

function buildPaths(data, W, H) {
  const pts = data.map((d, i) => [
    (i / (data.length - 1)) * W,
    H - (d.hours / MAX_H) * H,
  ]);
  const line = pts
    .map(
      (p, i) => `${i === 0 ? "M" : "L"}${p[0].toFixed(1)},${p[1].toFixed(1)}`,
    )
    .join(" ");
  const area = `${line} L${W},${H} L0,${H} Z`;
  return { line, area, pts };
}

/* ── Course data ── */
const COURSES = [
  {
    id: 1,
    title: "Projecting & design of interfaces",
    progress: 45,
    color: "#9b7de8",
    bg: "#ede7f6",
    img: "🎨",
  },
  {
    id: 2,
    title: "UX designer from scratch to PRO",
    progress: 80,
    color: "#4caf7d",
    bg: "#dff3e7",
    img: "✏️",
  },
  {
    id: 3,
    title: "Frontend basics. HTML and CSS",
    progress: 65,
    color: "#f0b429",
    bg: "#fff3cd",
    img: "💻",
  },
];

/* ── Payment data ── */
const PAYMENTS = [
  {
    id: 1,
    tag: "UI",
    tagColor: "#6c3fcf",
    tagBg: "#ede7f6",
    course: "Projecting & design of interfaces",
    date: "01.02.2024",
    price: "Rs 1,500",
    status: "pay",
  },
  {
    id: 2,
    tag: "CSS",
    tagColor: "#1565c0",
    tagBg: "#e3f2fd",
    course: "Frontend basics. HTML and CSS",
    date: "18.12.2023",
    price: "Rs 11,200",
    status: "paid",
  },
  {
    id: 3,
    tag: "UX",
    tagColor: "#6c3fcf",
    tagBg: "#ede7f6",
    course: "UX designer from scratch to PRO",
    date: "05.01.2024",
    price: "Rs 4,900",
    status: "paid",
  },
];

/* ── Events ── */
const EVENTS = {
  10: {
    label: "Figma webinar",
    time: "12.00 pm",
    badgeBg: "#781c2e",
    dotColor: "#f59e0b",
    borderColor: "#f59e0b",
    rowBg: "#fffbeb",
  },
  19: {
    label: "Code Review",
    time: "3.00 pm",
    badgeBg: "#1565c0",
    dotColor: "#60a5fa",
    borderColor: "#60a5fa",
    rowBg: "#eff6ff",
  },
  27: {
    label: "Group Workshop",
    time: "4.00 pm",
    badgeBg: "#2e7d32",
    dotColor: "#4caf7d",
    borderColor: "#4caf7d",
    rowBg: "#f0fdf4",
  },
};

/* ════════════ CALENDAR ════════════ */
function Calendar() {
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());
  const [sel, setSel] = useState(today.getDate());

  const dim = getDaysInMonth(year, month);
  const firstOff = getFirstDay(year, month);
  const isCur = year === today.getFullYear() && month === today.getMonth();

  const prev = () => {
    if (month === 0) {
      setMonth(11);
      setYear((y) => y - 1);
    } else setMonth((m) => m - 1);
  };
  const next = () => {
    if (month === 11) {
      setMonth(0);
      setYear((y) => y + 1);
    } else setMonth((m) => m + 1);
  };

  const cells = [];
  for (let i = 0; i < firstOff; i++) cells.push(null);
  for (let d = 1; d <= dim; d++) cells.push(d);

  return (
    <div className="card cal-card">
      <div className="cal-head">
        <button className="cal-nav" onClick={prev}>
          <ChevronL />
        </button>
        <span className="cal-month-lbl">{MONTHS[month]}</span>
        <button className="cal-nav" onClick={next}>
          <ChevronR />
        </button>
      </div>

      <div className="cal-grid">
        {DAYS.map((d) => (
          <span key={d} className="cal-dow">
            {d}
          </span>
        ))}
        {cells.map((cell, i) => {
          if (!cell) return <span key={`e${i}`} />;
          const isToday = isCur && cell === today.getDate();
          const isSel = !isToday && cell === sel;
          const ev = EVENTS[cell];
          return (
            <span
              key={cell}
              className={`cal-day${isToday ? " cal-today" : ""}${isSel ? " cal-sel" : ""}${ev ? " cal-ev" : ""}`}
              onClick={() => setSel(cell)}
              title={ev ? `${ev.label} — ${ev.time}` : ""}
            >
              {cell}
              {ev && (
                <span className="ev-dot" style={{ background: ev.dotColor }} />
              )}
            </span>
          );
        })}
      </div>

      <div className="cal-events">
        {Object.entries(EVENTS).map(([day, ev]) => (
          <div
            key={day}
            className="ev-row"
            style={{ borderLeftColor: ev.borderColor, background: ev.rowBg }}
          >
            <div className="ev-badge" style={{ background: ev.badgeBg }}>
              <span className="ev-day">{day}</span>
              <span className="ev-mon">
                {MONTHS[month].slice(0, 3).toUpperCase()}
              </span>
            </div>
            <div className="ev-info">
              <p className="ev-title">{ev.label}</p>
              <p className="ev-time">🕐 {ev.time}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ════════════ PRODUCTIVITY CHART ════════════ */
function ProductivityChart() {
  const W = 500,
    H = 120;
  const { line, area, pts } = buildPaths(WEEK_DATA, W, H);
  const [tip, setTip] = useState(null);

  return (
    <div className="card prod-card">
      <div className="card-head">
        <span className="card-title">Productivity</span>
        <span className="week-chip">Week ↓</span>
      </div>
      <div className="chart-wrap">
        <div className="y-axis">
          {[8, 6, 4, 2].map((v) => (
            <span key={v} className="y-label">
              {v} h
            </span>
          ))}
        </div>
        <div className="chart-body">
          <svg
            width="100%"
            height={H}
            viewBox={`0 0 ${W} ${H}`}
            preserveAspectRatio="none"
            className="chart-svg"
            onMouseLeave={() => setTip(null)}
          >
            <defs>
              <linearGradient id="cg" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#5bb5b5" stopOpacity="0.4" />
                <stop offset="100%" stopColor="#5bb5b5" stopOpacity="0.03" />
              </linearGradient>
            </defs>
            <path d={area} fill="url(#cg)" />
            <path
              d={line}
              fill="none"
              stroke="#5bb5b5"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            {pts.map(([x, y], i) => (
              <circle
                key={i}
                cx={x}
                cy={y}
                r="5"
                fill="#fff"
                stroke="#5bb5b5"
                strokeWidth="2.5"
                style={{ cursor: "pointer" }}
                onMouseEnter={() => setTip({ x, y, h: WEEK_DATA[i].hours })}
              />
            ))}
            {tip && (
              <g>
                <rect
                  x={tip.x - 26}
                  y={tip.y - 33}
                  width="52"
                  height="22"
                  rx="6"
                  fill="#1a1a2e"
                />
                <text
                  x={tip.x}
                  y={tip.y - 18}
                  textAnchor="middle"
                  fill="white"
                  fontSize="11"
                  fontWeight="600"
                >
                  {tip.h}h
                </text>
              </g>
            )}
          </svg>
          <div className="x-axis">
            {WEEK_DATA.map((d) => (
              <span key={d.day} className="x-label">
                {d.day}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ════════════ PROFILE CARD ════════════ */
function ProfileCard() {
  const XP_PER_LV = 500;
  const totalXp = 340;
  const level = 5;
  const xpToNext = XP_PER_LV - totalXp;
  const pct = Math.round((totalXp / XP_PER_LV) * 100);

  // ── localStorage se name ──
  const studentData = JSON.parse(localStorage.getItem("studentData") || "{}");
  const firstName =
    studentData?.firstName || localStorage.getItem("firstName") || "";
  const lastName =
    studentData?.lastName || localStorage.getItem("lastName") || "";
  const fullName =
    firstName && lastName ? `${firstName} ${lastName}` : firstName || "Student";
  const avatarLetter = fullName[0]?.toUpperCase() || "S";

  return (
    <div className="card arena-card">
      <div className="arena-bg" />
      <div className="arena-av-wrap">
        <div className="arena-av">
          <span className="arena-letter">{avatarLetter}</span>
        </div>
        <div className="arena-lv-badge">Lvl {level}</div>
      </div>
      <p className="arena-name">{fullName}</p>
      <p className="arena-sub">Code Arena Player</p>

      <div className="arena-xp-row">
        <span className="arena-xp-lbl">
          XP {totalXp} / {XP_PER_LV}
        </span>
        <span className="arena-xp-lbl">{pct}%</span>
      </div>
      <div className="arena-xp-bar">
        <div className="arena-xp-fill" style={{ width: `${pct}%` }} />
      </div>
      <p className="arena-next-lv">
        🚀 {xpToNext} XP to reach Level {level + 1}
      </p>

      <div className="arena-stats">
        <div className="arena-stat">
          <div className="arena-stat-icon" style={{ background: "#fff3e0" }}>
            <UsersIcon />
          </div>
          <span className="arena-stat-num">38</span>
          <span className="arena-stat-lbl">FRIENDS</span>
        </div>
        <div className="arena-stat">
          <div className="arena-stat-icon" style={{ background: "#fff8e1" }}>
            <StarIcon />
          </div>
          <span className="arena-stat-num">14</span>
          <span className="arena-stat-lbl">ACHIEVE</span>
        </div>
        <div className="arena-stat">
          <div className="arena-stat-icon" style={{ background: "#e8f5e9" }}>
            <ShieldIcon />
          </div>
          <span className="arena-stat-num">5.0</span>
          <span className="arena-stat-lbl">RATING</span>
        </div>
      </div>
    </div>
  );
}

/* ════════════ MAIN ════════════ */
export default function Dashboard() {
  const today = new Date();

  // ── localStorage se welcome name ──
  const studentData = JSON.parse(localStorage.getItem("studentData") || "{}");
  const firstName =
    studentData?.firstName || localStorage.getItem("firstName") || "";
  const email = studentData?.email || localStorage.getItem("email") || "";
  const displayName = firstName || email.split("@")[0] || "Student";

  return (
    <MyStudentLayout>
      <div className="db-wrap">
        {/* Welcome bar */}
        <div className="welcome-bar">
          <div>
            <h1 className="welcome-title">
              Welcome back, <span className="welcome-name">{displayName}</span>{" "}
              👋
            </h1>
            <p className="welcome-sub">Let's learn something new today</p>
          </div>
          <div className="date-chip">
            {today.toLocaleDateString("en-US", {
              weekday: "long",
              month: "long",
              day: "numeric",
            })}
          </div>
        </div>

        <div className="page-grid">
          {/* ===== LEFT COLUMN ===== */}
          <div className="left-col">
            {/* KPI cards */}
            <div className="kpi-row">
              <div className="kpi-card" style={{ background: "#e8e3f7" }}>
                <div
                  className="kpi-icon"
                  style={{
                    background: "rgba(155,125,232,0.25)",
                    color: "#6c3fcf",
                  }}
                >
                  <CheckIcon />
                </div>
                <div className="kpi-body">
                  <span className="kpi-num" style={{ color: "#6c3fcf" }}>
                    11
                  </span>
                  <span className="kpi-lbl">Completed courses</span>
                </div>
              </div>
              <div className="kpi-card" style={{ background: "#dff3e7" }}>
                <div
                  className="kpi-icon"
                  style={{
                    background: "rgba(76,175,125,0.25)",
                    color: "#2e7d32",
                  }}
                >
                  <BookIcon />
                </div>
                <div className="kpi-body">
                  <span className="kpi-num" style={{ color: "#2e7d32" }}>
                    06
                  </span>
                  <span className="kpi-lbl">Enrolled courses</span>
                </div>
              </div>
              <div className="kpi-card" style={{ background: "#f9e7b4" }}>
                <div
                  className="kpi-icon"
                  style={{
                    background: "rgba(240,180,41,0.3)",
                    color: "#c47f00",
                  }}
                >
                  <ClockIcon />
                </div>
                <div className="kpi-body">
                  <span className="kpi-num" style={{ color: "#c47f00" }}>
                    12
                  </span>
                  <span className="kpi-lbl">Pending courses</span>
                </div>
              </div>
            </div>

            {/* Productivity chart */}
            <ProductivityChart />

            {/* Courses */}
            <div className="card">
              <div className="card-head">
                <span className="card-title">Courses</span>
                <button className="view-all-btn">View all</button>
              </div>
              <div className="courses-row">
                {COURSES.map((c) => (
                  <div
                    key={c.id}
                    className="course-card"
                    style={{ background: c.bg }}
                  >
                    <div className="course-emoji">{c.img}</div>
                    <p className="course-name">{c.title}</p>
                    <div className="course-bar-wrap">
                      <div className="course-bar-bg">
                        <div
                          className="course-bar-fill"
                          style={{
                            width: `${c.progress}%`,
                            background: c.color,
                          }}
                        />
                      </div>
                      <span className="course-pct" style={{ color: c.color }}>
                        {c.progress}%
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Payment */}
            <div className="card">
              <div className="card-head">
                <span className="card-title">Payment</span>
                <button className="view-all-btn">View all</button>
              </div>
              <div className="table-wrap">
                <table className="pay-table">
                  <thead>
                    <tr>
                      <th>Course</th>
                      <th>
                        Date <span className="sort-ic">↕</span>
                      </th>
                      <th>
                        Price <span className="sort-ic">↕</span>
                      </th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {PAYMENTS.map((p) => (
                      <tr key={p.id}>
                        <td>
                          <div className="pay-course-cell">
                            <span
                              className="pay-tag"
                              style={{ color: p.tagColor, background: p.tagBg }}
                            >
                              {p.tag}
                            </span>
                            {p.course}
                          </div>
                        </td>
                        <td className="pay-date">{p.date}</td>
                        <td className="pay-price">{p.price}</td>
                        <td>
                          <button
                            className={`status-btn ${p.status === "pay" ? "btn-pay" : "btn-paid"}`}
                          >
                            {p.status === "pay" ? "Pay now" : "Already paid"}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* end left-col */}

          {/* ===== RIGHT COLUMN ===== */}
          <div className="right-col">
            <Calendar />
            <ProfileCard />
          </div>
        </div>
        {/* end page-grid */}
      </div>
    </MyStudentLayout>
  );
}
